import type {
  GetNotificationsSettingsResponse,
  SetNotificationContentPayload,
  SetNotificationContentResponse,
  SetNotificationsSettingsPayload,
} from "~/repository/notifications.types";

export async function getNotificationsSettings(): Promise<GetNotificationsSettingsResponse> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/subscribers/me/notifications`);
}

export async function setNotificationsSettings(
  payload: SetNotificationsSettingsPayload,
): Promise<SetNotificationContentResponse> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/subscribers/me/notifications`, {
    method: "POST",
    body: payload,
  });
}

export async function setNotificationContent(
  payload: SetNotificationContentPayload,
): Promise<SetNotificationContentResponse> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/subscribers/me/notifications/content`, {
    method: "POST",
    body: payload,
  });
}

export async function deleteNotificationContent(payload: {
  content_id: string;
}): Promise<SetNotificationContentResponse> {
  const { $api } = useNuxtApp();
  return await $api("v4")(
    `/subscribers/me/notifications/content/${payload.content_id}`,
    {
      method: "DELETE",
    },
  );
}
